import React, { Component } from "react";
import { addSeconds } from "date-fns";
import * as d3 from "d3";

export default class SleepChart extends Component {
  drawChart() {
    const data = this.getFormattedData(this.props.data);
    const SVGwidth = 840;
    const width = 800;
    const height = 400;
    const s = 10;
    const extent =
      data && data.length ? [data[0].start, data[data.length - 1].end] : [];
    const xScale = d3
      .scaleTime()
      .domain(extent)
      .range([40, width+40]);
    const yScale = d3
      .scaleOrdinal()
      .domain(["wake", "rem", "light", "deep"])
      .range([0, height * 0.3, height * 0.6, height * 0.9]);

    const svg = d3
      .select(`#${CSS.escape(this.props.user_id)}`)
      .append("svg")
      .attr("width", SVGwidth) // + margin.left + margin.right)
      .attr("height", height) // + margin.top + margin.bottom)
      .append("g")
      // .attr("transform", "translate(" + margin.left + ", " + margin.top + ")");
      .attr("transform", "translate(0, 0)");

    var defs = svg.append("defs");
    var gradient = defs
      .append("linearGradient")
      .attr("id", "stages-gradient")
      .attr("x1", "0%")
      .attr("y1", "0%")
      .attr("x2", "0")
      .attr("y2", "100%");

    gradient
      .append("stop")
      .attr("offset", "0%")
      .attr("stop-color", this.getColor("wake"))
      .attr("stop-opacity", 1);

    gradient
      .append("stop")
      .attr("offset", "30%")
      .attr("stop-color", this.getColor("rem"))
      .attr("stop-opacity", 1);

    gradient
      .append("stop")
      .attr("offset", "60%")
      .attr("stop-color", this.getColor("light"))
      .attr("stop-opacity", 1);

    gradient
      .append("stop")
      .attr("offset", "90%")
      .attr("stop-color", this.getColor("deep"))
      .attr("stop-opacity", 1);

    svg
      .append("path")
      .attr("class", "hypnogram")
      .attr("d", this.getHypnoGramPath(data))
      .style("fill", "url(#stages-gradient)");

    svg
      .append("path")
      .attr("class", "hypnogram-path")
      .attr("d", this.segmentPath()(this.getScaledPoints(data)))
      .style("fill", "none")
      .style("stroke", "url(#stages-gradient)");

    const xAxisGenerator = d3
      .axisBottom()
      .scale(xScale)
      .tickFormat(d3.timeFormat("%-I:%M"))
      .tickSizeOuter(0);

    svg
      .append("g")
      .attr("class", "axis-x")
      .attr("transform", "translate(0, " + (height - 20) + ")")
      .call(xAxisGenerator);

    const yAxisGenerator = d3
      .axisLeft()
      .scale(yScale)
      .tickFormat(
        d => d
        //yAxisLabels[d].toUpperCase();
      );

    svg
      .append("g")
      .attr("class", "axis-y")
      .attr("transform", "translate(35, 4)")
      .call(yAxisGenerator);
  }

  getScaledPoints(data) {
    const width = 800;
    const height = 400;
    const extent =
      data && data.length ? [data[0].start, data[data.length - 1].end] : [];
    const xScale = d3
      .scaleTime()
      .domain(extent)
      .range([40, width+40]);
    const yScale = d3
      .scaleOrdinal()
      .domain(["wake", "rem", "light", "deep"])
      .range([0, height * 0.3, height * 0.6, height * 0.9]);

    var points = [];

    data.forEach(d => {
      points.push([xScale(d.start), yScale(d.level)]);
      points.push([xScale(d.end), yScale(d.level)]);
    });

    console.log(points);
    return points;
  }

  segmentPath() {
    return d3.line().y(d => {
      return d[1] + 5;
    });
  }

  getHypnoGramPath(data) {
    var pts = [],
      // start = void 0,
      body = void 0;
    // end = void 0;

    data.forEach((d, i) => {
      // start = _this5.getStartJoint(d, i);
      body = this.getBodyJoint(d, i, false, false, data);
      pts.push(body);
      // end = _this5.getEndJoint(d, i);

      // pts.push(start, body, end);
    });

    return pts.join(" ");
  }

  getBodyJoint(d, i, isDisconnected, isCap, data) {
    const width = 800;
    const height = 400;
    const s = 10;
    const extent =
      data && data.length ? [data[0].start, data[data.length - 1].end] : [];
    const xScale = d3
      .scaleTime()
      .domain(extent)
      .range([40, width+40]);
    const yScale = d3
      .scaleOrdinal()
      .domain(["wake", "rem", "light", "deep"])
      .range([0, height * 0.3, height * 0.6, height * 0.9]);

    // var height = 200, // this.height,
    // segmentHeight = this.segmentHeight,
    // margin = this.margin,
    // data = this.hypnogramData;

    var x = xScale(d.start) - 0.5,
      y = yScale(d.level),
      w = xScale(d.end) - xScale(d.start) + 1,
      h = 20,
      /*
        isDisconnected && isCap !== true
          ? height + margin.top + margin.bottom
          : segmentHeight,
        */
      r = 2, // this.getRadius(w),
      tl = void 0,
      tr = void 0,
      bl = void 0,
      br = void 0;

    x = isDisconnected ? x + 0.5 : x;
    w = isDisconnected ? w - 1 : w;
    // if its the start or previous segment is lower
    if (
      i === 0 ||
      (i > 0 && data[i - 1].row > d.row) ||
      isDisconnected === true
    ) {
      tl = r;
    } else {
      tl = 0;
    }
    // if its last or next segment is lower
    if (
      i === data.length - 1 ||
      (i < data.length - 1 && data[i + 1].row > d.row) ||
      isDisconnected === true
    ) {
      tr = r;
    } else {
      tr = 0;
    }

    // if its first or previous segment is higher
    if ((i === 0 || (i > 0 && data[i - 1].row < d.row)) && isCap === false) {
      bl = r;
    } else {
      bl = 0;
    }

    // if its last or next segment is higher
    if (
      (i === data.length - 1 ||
        (i < data.length - 1 && data[i + 1].row < d.row)) &&
      isCap === false
    ) {
      br = r;
    } else {
      br = 0;
    }

    return this.getRoundedRectangle(x, y, w, h, r, tl, tr, bl, br, false);
  }

  getRoundedRectangle(x, y, w, h, r, tl, tr, bl, br, isClosed) {
    var rectangle = ["M " + (x + r) + ", " + y];

    rectangle.push("h " + (w - 2 * r));
    if (tr) {
      rectangle.push("a " + r + "," + r + " 0 0 1 " + r + "," + r);
    } else {
      rectangle.push("h " + r);
      rectangle.push("v " + r);
    }

    rectangle.push("v " + (h - 2 * r));
    if (br) {
      rectangle.push("a " + r + ", " + r + " 0 0 1 -" + r + "," + r);
    } else {
      rectangle.push("v " + r);
      rectangle.push("h -" + r);
    }

    rectangle.push("h " + (2 * r - w));
    if (bl) {
      rectangle.push("a " + r + ", " + r + " 0 0 1 -" + r + ",-" + r);
    } else {
      rectangle.push("h -" + r);
      rectangle.push("v -" + r);
    }

    rectangle.push("v " + (2 * r - h));
    if (tl) {
      rectangle.push("a " + r + ", " + r + " 0 0 1 " + r + ", -" + r);
    } else {
      rectangle.push("v -" + r);
      rectangle.push("h " + r);
    }

    if (isClosed) {
      rectangle.push("z");
    }

    return rectangle.join(" ");
  }

  getColor(e) {
    var t = [
      "rgb(247,56,110)",
      "rgb(124,196,255)",
      "rgb(58,135,255)",
      "rgb(15,72,169)"
    ];
    return "wake" === e
      ? t[0]
      : "rem" === e
        ? t[1]
        : "light" === e
          ? t[2]
          : "deep" === e
            ? t[3]
            : void 0;
  }

  getFormattedData(data) {
    var t = { wake: 0, rem: 1, light: 2, deep: 3 };

    return data.filter(d => d.type !== "shortData").map(d => {
      const start = new Date(d.time);
      const end = addSeconds(start, d.seconds);
      return {
        start,
        end,
        level: d.level,
        row: t[d.level]
      };
    });
  }

  componentDidMount() {
    this.drawChart();
  }

  render() {
    return <div id={`${this.props.user_id}`}  style={{ marginLeft: 40 }} />;
  }
}
